import { createActions, createReducer } from "reduxsauce"

export const { Types, Creators } = createActions({
  setTradeType: ["tradeType"],
  setOpenTradeId: ["id"],
}, {
  prefix: "ompnt/modules/rebalanceTrades",
})

const DEFAULT_STATE = {
  tradeType: "buy",
  openTradeId: null,
}

function handleSetTradeType(state, { tradeType }) {
  return { ...state, tradeType }
}

function handleSetOpenTradeId(state, { id }) {
  if (state.openTradeId === id) {
    id = null
  }

  return { ...state, openTradeId: id }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SET_TRADE_TYPE]: handleSetTradeType,
  [Types.SET_OPEN_TRADE_ID]: handleSetOpenTradeId,
})
